import React, { useState, useEffect, useContext, useRef } from 'react';
import moment from 'moment/moment';
import './index.css';
import WebcastingContext from '../context/webcasting/webcastingContext';

// Components
import HeadStyle from './HeadStyle';
import PendingArchive from './PendingArchive';
import UpcomingEvent from './UpcomingEvent';
import ZoomEvent from './ZoomEvent';
import WebcastingPlatform from './WebcastingPlatform';
import PrimusContainer from '../components/websocket/primusContainer';
import MessageToAll from '../components/UI/MessageToAll';
import { useWebcastSocket } from '../context/WebcastSocket.jsx';

// const Console = (props) => {
//   // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>> passed data to log: ', props);
//   return null;
// };

const LiveLayout = (props) => {
  const webcastingContext = useContext(WebcastingContext);
  const {
    loading,
    event,
    authorization,
    localData,
    getEvent,
    getAuthorization,
    readLocalData,
    liveLayout,
    liveStatus,
    branding,
    messageToAll
  } = webcastingContext;

  const { socket, currentRoom, connectionError, isDisconnected, joinRoom, leaveRoom, reconnectSocket, presenterId, slideId, isFullScreen, offset, lastEventMessage, lastPollTriggered, lastSurveyTriggered } = useWebcastSocket();
  //Join room
  useEffect(() => {
    if (!socket || !event?._id) return;

      joinRoom(event._id);
  
    return () => {
      console.log('Leaving room cleanup triggered');
      leaveRoom(event?._id);
    };
  }, [event?._id, socket, joinRoom, leaveRoom]);

  //Reconnect socket
  useEffect(() => {
    if (socket) {
      reconnectSocket();
    }
  }, [socket]);

  const companyName = useRef();

  // const [branding, setBranding] = useState(false);
  useEffect(() => {
    console.log('live????????????????????????///')
    getEvent(props.match.match.params.eventId);
    readLocalData(event, authorization);
    if (props.match.match.params.confirmationId) {
      getAuthorization(
        props.match.match.params.eventId,
        props.match.match.params.confirmationId
      );
    }
  }, [props.match.match.params.eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   if (event.items) {
  //     if (event.webcast.branding.fonts.length > 0) {
  //       event.webcast.branding.fonts.forEach(
  //         (i) => i.fontLinkHref !== '' && setBranding(true)
  //       );
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    companyName.current = event.companies[0].name;
    // eslint-disable-next-line
  }, []);

  const ssss = (event) => {
    return moment.utc(event.releaseTime).diff(moment());
  };

  console.log('eventFromLiveLayout,', event)
  console.log('liveLayoutv9v9v9', liveStatus)
if(event?.zoom?.enable) 
  return(
    <>
    {branding ? <HeadStyle branding={branding} /> : <HeadStyle />}
    <ZoomEvent
      match={props.match}
      loading={loading}
      event={event}
      saveAuth={true}
      authorization={props.match.match.params.confirmationId}
      localData={localData}
      timeToEvent={ssss(event)}
      brandingFound={branding}
    />
  </>
)
  const timingStatus = event?.webcast?.timing?.status;
  const isReset = liveLayout === 'reset' || liveStatus === 'reset';
  const forcedLiveByAdmin =
    !isReset &&
    (timingStatus === 'live' || liveLayout === 'live' || liveLayout === 'start');
  const isNotStarted = timingStatus === 'not_started' || liveLayout === 'reset';
  const isPausedOrStopped =
    timingStatus === 'paused' || timingStatus === 'stopped';

  // In preview mode ignore all socket-driven status — always show the platform.
  if (props.preview) {
    return (
      <>
        {branding ? <HeadStyle branding={branding} /> : <HeadStyle />}
        <WebcastingPlatform
          match={props.match}
          loading={loading}
          event={event}
          saveAuth={false}
          authorization={props.match.match.params.confirmationId}
          localData={localData}
          preview={true}
        />
      </>
    );
  }

  // Stopped / paused / pending archive must win over "forced live" from API timing,
  // otherwise WebcastingPlatform renders first and PendingArchive never shows.
  const showPendingArchive =
    liveLayout === 'stop' ||
    liveStatus === 'stop' ||
    isPausedOrStopped;

  const showWebcastingPlatform =
    !showPendingArchive &&
    !isReset &&
    (forcedLiveByAdmin ||
      liveLayout === 'start' ||
      liveLayout === 'live');

  // After socket/event restart, show holding page.
  const showUpcomingEvent =
    isReset || (!forcedLiveByAdmin && isNotStarted);

  console.log('showUpcomingEventfromLiveLayout', showUpcomingEvent, 'event?.webcast?.timing?.status', timingStatus, 'liveLayout')
  console.log('showPendingArchive', showPendingArchive, liveLayout, liveStatus)


  return (
    <>
      <>
        {branding ? <HeadStyle branding={branding} /> : <HeadStyle />}
        {showPendingArchive ? (
          <>
            <PendingArchive
              match={props.match}
              loading={loading}
              event={event}
              saveAuth={true}
              authorization={props.match.match.params.confirmationId}
              localData={localData}
              brandingFound={branding}
            />
          </>
        ) : showWebcastingPlatform ? (
          <>
            <WebcastingPlatform
              match={props.match}
              loading={loading}
              event={event}
              saveAuth={true}
              authorization={props.match.match.params.confirmationId}
              localData={localData}
              preview={props.preview}
            />
          </>
        ) : showUpcomingEvent ? (
          <>
            <UpcomingEvent
              match={props.match}
              loading={loading}
              event={event}
              saveAuth={true}
              authorization={props.match.match.params.confirmationId}
              localData={localData}
              timeToEvent={ssss(event)}
              brandingFound={branding}
            />
          </>
        ) : (
          <>
            <WebcastingPlatform
              match={props.match}
              loading={loading}
              event={event}
              saveAuth={true}
              authorization={props.match.match.params.confirmationId}
              localData={localData}
              preview={props.preview}
            />
          </>
        )}
      </>
      {/* {event?.webcast?.stream && (
        <>
          <PrimusContainer
            event={event}
            preview={props.preview}
          />
          <MessageToAll companyName={companyName.current} />
        </>
      )} */}
  {
   (event && Object.keys(messageToAll).length > 0) && <MessageToAll companyName={companyName?.current || ''} />

  }

      
      {/* <PrimusContainer event={props.event} preview={props.preview} /> */}
      {/* <MessageToAll companyName={companyName.current} /> */}
    </>
  );
};

export default React.memo(LiveLayout);
